import React from "react"
import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"

const OverviewComponent = ({ content }) => {
  console.log(content);
  
  const columnContent = content?.columns?.map((item, index) => {
    return (
      <Column key={item}>
        {item?.headline && (
          <ColumnHeadline
            customColor={content?.customColor}
            color={content?.color}
          >
            {item?.headline}
          </ColumnHeadline>
        )}
        {item?.body && (
          <Body dangerouslySetInnerHTML={{ __html: item?.body }} />
        )}
      </Column>
    )
  })
  return (
    <Wrapper>
      <Header>{content?.header}</Header>
      <ContentWrapper>{columnContent}</ContentWrapper>
    </Wrapper>
  )
}

export default OverviewComponent

const Body = styled.p`
  p {
    ${text.bodySm};
  }
  li {
    ${text.bodySm};
  }
`

const ColumnHeadline = styled.p`
  ${text.eyebrow};
  color: ${props =>
    props.$customColor ? colors[props.$color] : colors.lightPurple};
  margin-bottom: 1.389vw;
  ${media.fullWidth} {
    margin-bottom: 20px;
  }

  ${media.tablet} {
    margin-bottom: 1.953vw;
  }

  ${media.mobile} {
    margin-bottom: 4.673vw;
  }
`

const Column = styled.div`
  gap: 2.778vw;
  ${media.fullWidth} {
    gap: 40px;
  }

  ${media.tablet} {
    gap: 3.906vw;
  }

  ${media.mobile} {
    gap: 9.346vw;
  }
`

const ContentWrapper = styled.div`
  display: flex;
  background-color: ${colors.lightPurpleGrey};
  width: 79.444vw;
  border-radius: 0.556vw;
  padding: 2.778vw;
  gap: 2.778vw;

  ${media.fullWidth} {
    width: 1144px;
    border-radius: 8px;
    padding: 40px;
    gap: 40px;
  }

  ${media.tablet} {
    width: 92.188vw;
    border-radius: 0.781vw;
    padding: 3.906vw;
    gap: 3.906vw;
  }

  ${media.mobile} {
    flex-direction: column;
    width: 100vw;
    border-radius: 1.869vw;
    padding: 9.346vw 6.075vw;
    gap: 9.346vw;
  }
`
const Header = styled.h4`
  ${text.h4};
  ${media.mobile} {
    display: none;
  }
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 2.778vw 0;
  gap: 1.389vw;
  ${media.fullWidth} {
    margin: 40px 0;
    gap: 20px;
  }

  ${media.tablet} {
    margin: 3.906vw 0;
    gap: 1.953vw;
  }

  ${media.mobile} {
    margin: 9.346vw 0;
    gap: 4.673vw;
  }
`
